import {Checkbox} from '@wandb/components';
import React from 'react';
// eslint-disable-next-line wandb/no-deprecated-imports
import {Popup} from 'semantic-ui-react';

import {useRunSelectorFeatureDisabled} from '../RunSelectorFeaturesContext';

type RowVisibilityProps = {
  isHiddenByParallelCoordinatesOrScatterPlot: boolean;
  isSingleMode: boolean;
  onChangeVisibility: () => void;
  visibilityState: 'checked' | 'unchecked' | 'partial' | 'unknown';
};

export function RowVisibility({
  isHiddenByParallelCoordinatesOrScatterPlot,
  isSingleMode,
  onChangeVisibility,
  visibilityState,
}: RowVisibilityProps) {
  const isDisabled = useRunSelectorFeatureDisabled();

  if (isSingleMode || isDisabled('toggle-visibility')) {
    return null;
  }

  const checkbox = (
    <Checkbox
      data-test="run-visibility-checkbox"
      isSelected={visibilityState === 'checked'}
      isIndeterminate={visibilityState === 'partial'}
      aria-label={visibilityState === 'checked' ? 'Hide run' : 'Show run'}
      variant="visibility"
      onClick={onChangeVisibility}
    />
  );

  if (isHiddenByParallelCoordinatesOrScatterPlot) {
    return (
      <Popup
        inverted
        position="right center"
        content="This run is hidden by a parallel coordinates or scatter plot. Deselect the range on that chart first."
        size="mini"
        on="hover"
        trigger={checkbox}
        offset={-3}
        popperModifiers={{
          preventOverflow: {
            // prevent popper from erroneously constraining the popup to the
            // table header
            boundariesElement: 'viewport',
          },
        }}
      />
    );
  }

  return checkbox;
}
